export const features = {
  install(app) {
    app.config.globalProperties.$hasFeature = (feature) => app.config.globalProperties.$store.state.session.tokenData?.features[feature] === true;
  },
};
